import { render, staticRenderFns } from "./editPopup.vue?vue&type=template&id=2a78c38c"
import script from "./editPopup.vue?vue&type=script&lang=js"
export * from "./editPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports